/* SET STATE */
export const SET_STATE_EMAREGULATION = "SET_STATE_EMAREGULATION"

/* EMAREGULATIONS */
export const GET_EMAREGULATIONS = "GET_EMAREGULATIONS"
export const GET_EMAREGULATIONS_SUCCESS = "GET_EMAREGULATIONS_SUCCESS"
export const GET_EMAREGULATIONS_FAIL = "GET_EMAREGULATIONS_FAIL"

/* EMAREGULATION */
export const GET_EMAREGULATION = "GET_EMAREGULATION"
export const GET_EMAREGULATION_SUCCESS = "GET_EMAREGULATION_SUCCESS"
export const GET_EMAREGULATION_FAIL = "GET_EMAREGULATION_FAIL"

/**
 * ADD EMAREGULATION
 */
 export const ADD_NEW_EMAREGULATION = "ADD_NEW_EMAREGULATION"
 export const ADD_EMAREGULATION_SUCCESS = "ADD_EMAREGULATION_SUCCESS"
 export const ADD_EMAREGULATION_FAIL = "ADD_EMAREGULATION_FAIL"

 /**
 * UPDATE EMAREGULATION
 */
export const UPDATE_EMAREGULATION = "UPDATE_EMAREGULATION"
export const UPDATE_EMAREGULATION_STATUS = "UPDATE_EMAREGULATION_STATUS"
export const UPDATE_EMAREGULATION_SUCCESS = "UPDATE_EMAREGULATION_SUCCESS"
export const UPDATE_EMAREGULATION_FAIL = "UPDATE_EMAREGULATION_FAIL"

/**
 * DELETE EMAREGULATION
 */
export const DELETE_EMAREGULATION = "DELETE_EMAREGULATION"
export const DELETE_EMAREGULATION_SUCCESS = "DELETE_EMAREGULATION_SUCCESS"
export const DELETE_EMAREGULATION_FAIL = "DELETE_EMAREGULATION_FAIL"
